import ProjectPresetsParentListComponent from './presets-parent-list.component'

export default ProjectPresetsParentListComponent
